import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Toast } from "primereact/toast";

import CrudPrioridadesModal from "./PrioridadesModal/CrudPrioridadesModal";

import { obtenerPrioridades } from "../../../API/Global/Prioridades/PrioridadesRequests";
import Card from "../../../Components/Card/Card";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { Button } from "primereact/button";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";

// import './categoriaStyle.scss';

export const PrioridadesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [prioridades, setPrioridades] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const tp = await obtenerPrioridades();
    setPrioridades(tp);
    setLoading(false);
  };


  const colums = [
    {
      field: "IdPriority",
      header: "ID",
      headerEn: "ID",
      className:"XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "PriorityCategory",
      header: "Categoría",
      headerEn: "Category",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    { field: "Priority", header: "Prioridad", headerEn: "Priority", flex: 1 },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "IdPriority",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: prioridades,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Prioridades", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Prioridades", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <CrudPrioridadesModal
          toastRef={toast}
          prioridadesDialog={showDialog}
          prioridad={selected}
          setPrioridadesDialog={setShowDialog}
          getPrioridades={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default PrioridadesScreen;
